import { useState } from "react";
import {
    Alert,
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Label,
    Row,
    Table
} from "reactstrap";

import GroupService from "../Services/GroupService";
import { GroupImportResultDto } from "../types/Group";

const ImportGroupPage = () => {

  const [groupFile, setGroupFile] = useState<File | null>(null); 

    const [loading, setLoading] =
        useState(false);

    const [result, setResult] =
        useState<GroupImportResultDto | null>(null);

    const [error, setError] =
        useState("");

    const handleImport = async () => {

        if (!groupFile  )
{
    setError("Please select both Excel files.");
    return;
}

        try {

            setLoading(true);

            setError("");
 
          const response =
    await GroupService.importExcel(
        groupFile, 
    );

            setResult(response);

        }
        catch {

            setError("Failed to import Excel.");

        }
        finally {

            setLoading(false);

        }

    };

    return (

        <Container className="py-5" style={{maxWidth:"900px"}}>

            <Card
            style={{
                border:"none",
                borderRadius:"20px",
                overflow:"hidden",
                boxShadow: "0 15px 35px rgba(0,0,0,.12)"           }}>

                <CardHeader
      style={{
        background: "linear-gradient(135deg,#2563eb,#4f46e5)",
        color: "#fff",
        padding: "25px",
        border: "none",
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h3 className="mb-1 fw-bold">
            📂 Import Groups
          </h3>

          <small style={{ opacity: 0.9 }}>
            Upload Group and Location Excel files to import data.
          </small>
        </div>

        <div
          style={{
            fontSize: "45px",
          }}
        >
          📊
        </div>
      </div>
    </CardHeader>

                <CardBody
                style={{
        background: "#f8fafc",
        padding: "35px",
      }}
      >

                    {
                        error &&
                        <Alert color="danger" style={{
            borderRadius: "12px",
          }}>
                            {error}
                        </Alert>
                    }
 <Row className="g-4">

        <Col md="6">
          <Card
            body
            style={{
              borderRadius: "15px",
              border: "2px dashed #2563eb",
              background: "#fff",
            }}
          >
            <Label className="fw-bold">
              📘 Group Excel
            </Label>

<input
    type="file"
    accept=".xlsx,.xls"
    className="form-control"
    onChange={(e) => {

        if (e.target.files?.length) {

            setGroupFile(
                e.target.files[0]
            );

        }

    }}
/>

   </Card>
        </Col>
                    
        </Row>
  <div className="text-center mt-5">
                    <Button
                        color="primary"
                        onClick={handleImport}
                        disabled={loading}
                        size="lg"
          style={{
            borderRadius: "30px",
            padding: "12px 45px",
            fontWeight: "bold",
          }}
                    >
                        {
                            loading
                                ? "⏳ Importing..."
                                : "🚀 Import Excel"
                        }
                    </Button>
                         </div>

                    {result && (
        <>
          <hr className="my-5" />

          <Row className="text-center">

            <Col md="4">
              <Card
                body
                style={{
                  borderRadius: "15px",
                  background: "#e0f2fe",
                  border: "none",
                }}
              >
                <h3>{result.totalRows}</h3>
                <p className="mb-0">Total Rows</p>
              </Card>
            </Col>

            <Col md="4">
              <Card
                body
                style={{
                  borderRadius: "15px",
                  background: "#dcfce7",
                  border: "none",
                }}
              >
                <h3>{result.successCount}</h3>
                <p className="mb-0">Successful</p>
              </Card>
            </Col>

            <Col md="4">
              <Card
                body
                style={{
                  borderRadius: "15px",
                  background: "#fee2e2",
                  border: "none",
                }}
              >
                <h3>{result.failedCount}</h3>
                <p className="mb-0">Failed</p>
              </Card>
            </Col>

          </Row>

          {result.errors.length > 0 && (
            <>
              <h4 className="mt-5 mb-3">
                ❌ Failed Rows
              </h4>

              <Table
                responsive
                hover
                bordered
                className="align-middle"
              >
                <thead
                  style={{
                    background: "#2563eb",
                    color: "#fff",
                  }}
                >
                  <tr>
                    <th>Row</th>
                    <th>Group Name</th>
                    <th>Error</th>
                  </tr>
                </thead>

                <tbody>
                  {result.errors.map((x, index) => (
                    <tr key={index}>
                      <td>{x.rowNumber}</td>
                      <td>{x.groupName}</td>
                      <td>{x.error}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </>
      )}
    </CardBody>
  </Card>
</Container>

    );

};

export default ImportGroupPage;